export const PathIcons = "/assets/custom-icons/icons.json?v1";
